export default __webpack_public_path__ + "static/media/resultsIcon.ca11c86b.png";